import { isEmpty } from 'lodash'
import { File } from '../../../api'
import FileIcon from '../../../assets/file.svg'
import styles from '../FormStepsLegacy.module.css'

export const FileComponentLegacy = ({ file, index, field }: { file: File; index: number; field: string }) => {
  return (
    <div
      className={styles.fileContainer}
      key={`${field}-${index}`}>
      <img
        src={FileIcon}
        className={styles.fileIcon}
      />
      <div className={styles.fileNameContainer}>
        <span
          className={styles.fileName}
          onClick={() => {
            if (!isEmpty(file.url)) {
              window.open(file.url, '_blank', 'noopener,noreferrer')
            }
          }}>
          {file.filename}
        </span>
      </div>
    </div>
  )
}
